/** Levenshtein edit distance between two strings. */
export function editDistance(a, b) {
  a = String(a);
  b = String(b);
  if (a === b) return 0;
  if (!a.length) return b.length;
  if (!b.length) return a.length;
  let prev = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    const cur = [i];
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
    }
    prev = cur;
  }
  return prev[b.length];
}

/**
 * Is `guess` close enough to `target` to count as the same word? Exact
 * match always; otherwise a length-scaled typo tolerance (0 for very short
 * names so "mew" ≠ "meh", up to 2 for long ones).
 */
export function closeEnough(guess, target) {
  if (!guess || !target) return guess === target;
  if (guess === target) return true;
  const tol = target.length <= 4 ? 0 : target.length <= 7 ? 1 : 2;
  return editDistance(guess, target) <= tol;
}
